import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <div className=' w-full bg-[#242424] grid grid-cols-10 pt-20 pb-10'>

      <div className=' col-start-2 col-span-8 h-full w-full grid grid-cols-1 md:grid-cols-3'>






        <div className='h-full w-full  flex flex-col justify-between'>



          <div className='flex flex-col mb-20'>

            <Link to={'/'} className='flex md:!hidden flex-col space-y-5 mb-10 md:mb-0 items-start md:items-end cursor-pointer'>
              <img src='/images/logo.svg' className='h-14' />
            </Link>


            <h3 className='text-customGray2 font-extralight text-35 mb-5'>{t("footer.contact.title")}</h3>

            <div className=' space-y-5'>
              <div className='flex space-x-2  items-center group'>
                <div className=' h-6 w-6  flex justify-center items-center'>
                  <img src='/images/footer/contact/mobile.svg' className='h-6   opacity-50 group-hover:opacity-100 transition-all duration-200' />
                </div>
                <a  href='+902582691341' target='_blank' className='font-extralight text-16 text-customGray2  cursor-pointer group-hover:text-white transition-all duration-200  '>{t("footer.contact.phone")}</a>
              </div>


              <div className='flex space-x-2  items-center group'>
                <div className=' h-6 w-6  flex justify-center items-center'>
                  <img src='/images/footer/contact/location.svg' className='h-6   opacity-50 group-hover:opacity-100 transition-all duration-200' />
                </div>
                <a href='https://maps.app.goo.gl/zy7sR78GXzSFALWK7' target='_blank' className='font-extralight text-16 text-customGray2  cursor-pointer group-hover:text-white transition-all duration-200'>{t("footer.contact.address")}</a>
              </div>

              <div className='flex space-x-2  items-center group'>
                <div className=' h-6 w-6  flex justify-center items-center'>
                  <img src='/images/footer/contact/mail.svg' className='h-6  opacity-50 group-hover:opacity-100 transition-all duration-200' />
                </div>

                <a href='mailto:doksan@doksan.com' target='_blank' className='font-extralight text-16 text-customGray2 hover:text-white cursor-pointer group-hover:text-white transition-all duration-200'>doksan@doksan.com</a>
              </div>



            </div>


          </div>



          <div className=''>



            <div className='space-y-10  group'>
              <a href='https://www.google.com/maps/dir//Dok-San+Tekstil+Denizli+Dokuma+Sanayi,+2.+Organize+Sanayi+Bolgesi,+H%C3%BCsn%C3%BC+%C3%96rnek+Cd.+No:2-4,+20065+Honaz%2FDenizli/@37.801773,29.244184,929m/data=!3m1!1e3!4m9!4m8!1m0!1m5!1m1!1s0x14c73f1f92866e6d:0x9ef3b828faaa57ce!2m2!1d29.244184!2d37.801773!3e0?entry=ttu&g_ep=EgoyMDI0MTIwMS4xIKXMDSoASAFQAw%3D%3D' target='_blank'><div className='border inline-block px-10 py-2.5 text-16  border-[rgba(199,199,199,0.6)] bg-[rgba(111,111,111,0.6)] group-hover:bg-[rgba(255,255,255,1)] font-light group-hover:text-[rgba(199,199,199,0.6)] text-white duration-200  cursor-pointer'>{t("footer.contact.getDirections")}</div></a>
              <div className='font-extralight text-12 text-white opacity-90 hidden md:block'>{t("footer.copyright")}</div>
            </div>


          </div>








        </div>








        <div className='h-full w-full  flex flex-col justify-between'>

          <div className='flex flex-col space-y-5 mb-10'>

            <h3 className='text-customGray2 font-extralight text-35 mt-14 md:mt-0'>{t("footer.followUs.title")}</h3>

            <div className='flex space-x-6  '>

              <img src='/images/social-media/i.svg' className='opacity-50 hover:opacity-100 transition-all duration-200 w-7 cursor-pointer' />
              <img src='/images/social-media/f.svg' className='opacity-50 hover:opacity-100 transition-all duration-200 w-7 cursor-pointer' />
              <img src='/images/social-media/x.svg' className='opacity-50 hover:opacity-100 transition-all duration-200 w-7 cursor-pointer' />
              <img src='/images/social-media/y.svg' className='opacity-50 hover:opacity-100 transition-all duration-200 w-7 cursor-pointer' />

            </div>

          </div>


          {/* <div className='flex flex-col font-extralight text-16 text-customGray2'>
            <a className='block'>KULLANIM KOŞULLARI</a>
            <a className='block'>ÇEREZ POLİTİKASI</a>
            <a className='block'>GİZLİLİK POLİTİKASI</a>
            <a className='block'>KVKK-GENEL AYDINLATMA METNİ</a>
            <a className='block'>KİŞİSEL VERİLERİ SAKLAMA VE İMHA POLİTİKASI</a>


          </div> */}

        </div>








        <div className='h-full w-full  flex flex-col justify-between'>


          <Link to={'/'} className='hidden md:flex flex-col space-y-5 mb-10 items-start md:items-end'>
            <img src='/images/logo.svg' className='h-14' />
          </Link>


          <div className='flex flex-col'>



            <div className='grid  grid-cols-1 md:grid-cols-2'>

              <div></div>
              <div className='space-y-3'>

                <div className=' font-extralight text-16 text-customGray2'>
                  {t("footer.complaint.text1")}
                  <br />
                  {t("footer.complaint.text2")}
                </div>

                <img src='/images/qr.svg' className='h-16' />

                <a href='https://s.ulula.app/S4Cturkey' target='_blank' className='block font-extralight text-16 text-customGray2 hover:text-white duration-200'>
                  {t("footer.complaint.text3")}
                  <br />
                  {t("footer.complaint.link")}
                </a>

                <a href='https://www.belgemodul.com/sirket/604' target='_blank' className='block font-extralight text-16 text-customGray2 hover:text-white duration-200 pt-10'>
                  {t("header.menu.informationSociety")}
                </a>
              </div>


        



              <div className='mt-7'>

                <div className='font-extralight text-12 text-white opacity-90 block md:hidden'>{t("footer.copyright")}</div>
              </div>

            </div>

          </div>


        </div>


      </div>

    </div>
  )
}

export default Footer